import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import InCountry from "../../Components/InCountry/InCountry";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import CountriesBlueButtons from "../../Components/CountriesBlueButtons/CountriesBlueButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { getDiseaseDetails } from "../../redux/InformationSlice";
import { Link, useParams } from "react-router-dom";
import s from "./PAS.module.scss";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import { useTranslation } from "react-i18next";
import { Seo } from "../../Seo";

interface Props {
  navigation: {
    name: string;
    path: string;
  };
}

const PAS = () => {
  const dispatch: AppDispatch = useDispatch();
  const disease = useSelector((state: RootState) => state.info.diseaseDetails);
  const params = useParams();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getDiseaseDetails(Number(params.id)));
  }, []);

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Seo
        title="Тест на употребление наркотиков для мигрантов в России"
        description="Как мигранту подготовиться к медосмотру и тесту на употребление наркотиков, ответственность за хранение и перевозку наркотиков"
        url="https://www.vputi.org/russia/pre-departure/pas/4"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство России / Психоактивные вещества",
            path: "/russia",
          }}
        />
        <ContactButtons />
        <div className={s.inner}>
          <div className={s.text}>
            <div className={s.text_title}>{disease?.title_1}</div>
            <div
              className={s.body}
              dangerouslySetInnerHTML={{ __html: disease?.body_1 ?? "" }}
            ></div>
          </div>{" "}
          <div className={s.body_2_wrapper}>
            <div
              className={s.body2}
              dangerouslySetInnerHTML={{ __html: disease?.body_2 ?? "" }}
            ></div>
          </div>
          <div
            className={s.body3}
            dangerouslySetInnerHTML={{ __html: disease?.body_3 ?? "" }}
          ></div>
          <div className={s.body_yellow_wrapper}>
            <div
              className={s.body_yellow}
              dangerouslySetInnerHTML={{ __html: disease?.body_4 ?? "" }}
            ></div>
          </div>
          <div className={s.buttons}>
            {
              <Link to={"/russia/pre-departure/pas/4"} className={s.button}>
                {t("Для мигрантов, употребляющих психоактивные вещества")}
              </Link>
            }
          </div>
          <div className={s.title}>
            {t("Где я могу пройти обследования на родине?")}
          </div>
          <CountriesBlueButtons />
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default PAS;
